// import NoDataResponseImage from "../Assests/no-data-img.png";
import NoDataResponseImage from "../Assests/NoDataIllustration.png";

const NoDataResponse = ({
  topText,
  bottomText,
  course,
  buttonText,
  onButtonClick,
}) => {
  return (
    <div
      className={`flex flex-col items-center justify-center text-center ${
        !course && "mb-20"
      } ${course && "bg-white"}`}
    >
      <img
        className="w-[250px] md:w-[350px] 2xl:w-[500px]"
        src={NoDataResponseImage}
        alt="data-not-found"
      />
      {topText ? (
        <p className="mt-3 text-[20px] font-medium text-[#3F3A7A] md:text-[22px] 2xl:text-[24px]">
          {topText}
        </p>
      ) : null}
      {bottomText ? (
        <div className="mt-1 flex w-full items-center justify-center">
          <p className="w-[90%] text-[16px] text-[#3F3A7A] md:w-[70%] md:text-[18px] 2xl:text-[20px]">
            {bottomText}
          </p>
        </div>
      ) : null}
      {buttonText ? (
        <button
          type="button"
          onClick={onButtonClick}
          className="mt-6 cursor-pointer rounded-[12px] border-none bg-[#A1A3EF] px-8 py-3 text-[20px] text-white shadow-md transition hover:shadow-lg md:text-[18px]"
        >
          {buttonText}
        </button>
      ) : null}
    </div>
  );
};

export default NoDataResponse;
